import React from 'react';
import { InlineWidget } from 'react-calendly';
import { Code } from 'react-feather';
import styled from 'styled-components';
import Title from 'components/blog/title';
import Body from 'components/common/body';
import Link from 'components/common/link';
import Container from 'components/container';
import PublicLayout from 'components/layouts/Public';
import { CALENDLY_15MIN_EMBED_URL, MAKE_MEET_LINK } from 'constants/urls';
import { theme } from 'utils/theme';

// TODO: move this to just one component for all pages
const FullWidthDiv = styled.div<{ margin?: string }>`
  width: 100%;
  display: flex;
  justify-content: left;
  align-items: left;
`;

const MeetPage = () => {
  return (
    <PublicLayout title="Meet">
      <Container centerContent py="20px" pylg="20px">
        <FullWidthDiv>
          <Title margin="15px 0 15px 40px">Let&apos;s have a chat</Title>
        </FullWidthDiv>
        <FullWidthDiv margin="0 0 20px 0">
          <Link href={MAKE_MEET_LINK('30min')}>
            <Body color={theme.customColors.linkBlue} margin="0 5px 0 40px">
              We need 30min
            </Body>
          </Link>

          <Code size={20} />

          <Link href={MAKE_MEET_LINK('60min')}>
            <Body color={theme.customColors.linkBlue} margin="0 0 0 5px">
              We need 60min
            </Body>
          </Link>
        </FullWidthDiv>
        <InlineWidget
          url={CALENDLY_15MIN_EMBED_URL}
          styles={{
            width: '100%',
            height: '1000px', // issue with scrolling; this value works well in practice
            overflow: 'hidden',
          }}
        />
      </Container>
    </PublicLayout>
  );
};

export default MeetPage;
